import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../../../shared/styles/colors';

const NavigationWrapper = styled.nav`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${colors.accentWhite};
    box-shadow: 0px 18px 36px -18px rgba(0, 0, 0, 0.05);
    max-width: 1280px;
    border-radius: 12px;
    width: 100%;
    margin: 0 auto;
    
    @media (max-width: 1024px) {
        display: none;
    }
`;

const NavItem = styled(NavLink)`
  color: ${colors.accentPrimary};
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  padding: 18px 30px;
  margin: 10px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  &.active {
    background: ${colors.accentPrimary};
    color: ${colors.accentWhite};
  }
`;

export const Navigation: FC = () => {
  return (
    <NavigationWrapper>
      <NavItem to="/profile">Персональний кабінет</NavItem>
      <NavItem to="/notifications">Сповіщення</NavItem>
      <NavItem to="/purchases">Мої покупки</NavItem>
      <NavItem to="/consultations">Мої консультації</NavItem>
      <NavItem to="/achievements">Досягнення</NavItem>
      <NavItem to="/faq">FAQ</NavItem>
    </NavigationWrapper>
  );
};